import * as React from "react";
import { cx } from "@nju/css";
import { ISlot } from "@nju/data-access-portal-appointment";

interface ISlotProps {
  isSelected: boolean;
  timeSlot: ISlot;
  onSlotSelect: (slot: ISlot) => void;
}

export function Slot({ isSelected, timeSlot, onSlotSelect }: ISlotProps) {
  const handleOnPress = React.useCallback(() => {
    onSlotSelect(timeSlot);
  }, [onSlotSelect, timeSlot]);

  return (
    <li
      className={cx(
        "my-1 rounded-[12px] text-daintree relative px-2",
        isSelected && "bg-brightCerulean text-white",
      )}
      data-cy="time-slot"
      onClick={handleOnPress}
      role="button"
    >
      {new Date(timeSlot.startDate).toLocaleString("pl-Pl", {
        hour: "numeric",
        minute: "numeric",
      })}{" "}
      -{" "}
      {new Date(timeSlot.endDate).toLocaleString("pl-Pl", {
        hour: "numeric",
        minute: "numeric",
      })}
    </li>
  );
}
